<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [header]="'folder.terminate.label' | translate"
  >
  <ng-container>
    @if (store.isApplicant()) {
      <div class="flex flex-column gap-3 pt-3">
        <app-date-input [form]="form" id="dateFrom" label="folder.terminate.fields.dateFrom"></app-date-input>
        <app-text-area-input [form]="form" id="message"
          label="folder.terminate.fields.message"
        ></app-text-area-input>
        <app-check-input [form]="form" id="isDead" label="folder.terminate.fields.isDead"></app-check-input>
        @if (form.value.isDead) {
          <app-date-input [form]="form" id="dateDeath" [maxDate]="today"
            label="folder.terminate.fields.dateDeath"
          ></app-date-input>
        }
      </div>
    }

    @if (store.isDead()) {
      <div class="flex flex-column gap-3 pt-3">
        <app-date-input [form]="form" id="dateFrom" label="folder.terminate.fields.dateFrom"></app-date-input>
        <app-text-area-input [form]="form" id="message"
          label="folder.terminate.fields.message"
        ></app-text-area-input>
      </div>
    }

    @if (!store.isApplicant() && !store.isDead()) {
      <div class="flex flex-column gap-3 pt-3">
        <app-date-input [form]="form" id="dateDeath" [maxDate]="today"
          label="folder.terminate.fields.dateDeath">
        </app-date-input>
        <app-text-area-input [form]="form" id="message"
          label="folder.terminate.fields.message"
        ></app-text-area-input>
        <app-check-input [form]="form" id="isClosed" label="folder.terminate.fields.isClosed"></app-check-input>
        @if (form.value.isClosed) {
          <app-date-input [form]="form" id="dateFrom"
            label="folder.terminate.fields.dateFrom"
          ></app-date-input>
        }
      </div>
    }

    <app-error-float-message [visible]="err !== null" [message]="err"></app-error-float-message>
  </ng-container>

  <ng-template #footer>
    <div class="dialogButtons">
      <app-cancel-button (clickEvent)="show(false)"></app-cancel-button>
      <app-confirm-button label="inputs.conclude" (clickEvent)="save()"></app-confirm-button>
    </div>
  </ng-template>
</p-dialog>
